import { render } from "./PreviousEditionSection.vue?vue&type=template&id=69ee1b2c&scoped=true"
import script from "./PreviousEditionSection.vue?vue&type=script&lang=js"
export * from "./PreviousEditionSection.vue?vue&type=script&lang=js"

import "./PreviousEditionSection.vue?vue&type=style&index=0&id=69ee1b2c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ee1b2c"]])

export default __exports__